module.exports = __webpack_public_path__ + "img/invoice-de-female-wm-hb.e19aac59.png";